<template>
    <div class="col-12">
        <div class="row">
            <div class="col-md-6">
                <TiendaSelectComponent :current="current" id="tienda_selector" />
            </div>
            <div class="col-md-5">
                <label>Nombre Cliente</label>
                <div class="d-flex align-items-center">
                    <input class="form-control form-control-sm bright me-2" placeholder="Search" type="text"
                        style="flex: 1;" />
                </div>
            </div>
            <div class="col-md-6">
                <label>Serie</label>
                <div class="d-flex align-items-center">
                    <input class="form-control form-control-sm bright me-2" placeholder="ABC" type="text"
                        style="flex: 1;" />
                </div>
            </div>
            <div class="col-md-6">
                <label>Número Documento</label>
                <div class="d-flex align-items-center">
                    <input class="form-control form-control-sm bright me-2" placeholder="#" type="text"
                        style="flex: 1;" />
                    <button class="btn btn-link btn-sm" type="button">
                        <i class="fa fa-search"></i> Buscar
                    </button>
                </div>
            </div>
        </div>
        <br>
        <div>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">Tienda</th>
                        <th scope="col">Cliente</th>
                        <th scope="col">Fecha</th>
                        <th scope="col">Serie</th>
                        <th scope="col">Número</th>
                        <th scope="col">Monto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.results" :key="item.id">
                        <th>{{ item.tienda }}</th>
                        <td>{{ item.cliente_nombre }}</td>
                        <td>{{ item.fecha }}</td>
                        <td>{{ item.cargo_serie }}</td>
                        <td>{{ item.numero }}</td>
                        <td>{{ item.valor_total }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
    components: {
        TiendaSelectComponent,
    },
    data() {
        return {
            data: {
                results: [],
            },
            current: {
                tienda: '02',
            }
        }
    },
    mounted() {
        let self = this;
        self.fetchData();
    },
    methods: {
        fetchData() {
            let self = this;
            DynamicService.fetch("cxc", "reclamo-cliente").then((response) => {
                self.data = response.data;
            });
        },
    }
}
</script>
<style></style>